export default "__VITE_ASSET__Dl1W7rGR__"